import React, {useState, useEffect} from 'react';
import {useDispatch} from 'react-redux';
import {Dropdown} from 'react-bootstrap';
import Image from '../../UI/Image';

import {setGrayscaleMode} from '../../../redux/actions/globalConfig';
import gear from '../../../../assets/gear.svg';
import './styles.less';

const Settings = () => {
  const [fontSize, setFontSize] = useState<string>('10px');
  const [greyScaleMode, setGreyScaleMode] = useState<boolean>(false);

  const dispatch = useDispatch();

  useEffect(() => {
    const greyMode = localStorage.getItem('greyMode');
    const fontSize = localStorage.getItem('fontSize');

    if (greyMode === 'true') setGreyScaleMode(true);

    if (fontSize) {
      setFontSize(fontSize);
      document.getElementsByTagName('html')[0].style.fontSize = fontSize;
    }
  }, []);

  const changeMode = (): void => {
    setGreyScaleMode(!greyScaleMode);
    dispatch(setGrayscaleMode((!greyScaleMode).toString()));
    localStorage.setItem('greyMode', (!greyScaleMode).toString());
  };

  const changeFont = (font: string): void => {
    const page = document.getElementsByTagName('html')[0];

    localStorage.setItem('fontSize', font);

    setFontSize(font);

    page.style.fontSize = font;
  };

  return (
    <Dropdown className='ac-header-settings' autoClose='outside'>
      <Dropdown.Toggle
        variant='secondary'
        className='ac-header-settings__button'
        id='accessibility_settings'
        aria-label='accessbility settings'
      >
        <Image
          attr={{
            src: gear,
            alt: 'settings',
            width: '16',
            height: '16',
          }}
        />
      </Dropdown.Toggle>

      <Dropdown.Menu className='ac-header-settings__dropdown'>
        <div>
          <p>Your font size</p>
          <div className='ac-header-settings__font-size'>
            <button
              onClick={() => changeFont('10px')}
              className={`${fontSize === '10px' ? 'active' : ''}`}
            >
              A
            </button>
            <button
              onClick={() => changeFont('12.5px')}
              className={`${fontSize === '12.5px' ? 'active' : ''}`}
            >
              A
            </button>
            <button
              onClick={() => changeFont('13.5px')}
              className={`${fontSize === '13.5px' ? 'active' : ''}`}
            >
              A
            </button>
          </div>
        </div>
        <button onClick={changeMode} className='greymode-button'>
          Grayscale mode {greyScaleMode === true ? 'on' : 'off'}
        </button>
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default Settings;
